console.log = function(){};
console.info = function(){};
console.error = function(){};
console.warn = function(){};